import React from "react";

import Icon from "../../Elements/Icon";
import Button from "../../Elements/Button";

export interface FourZeroFourProps {
	title: string;
	icon?: string;
	content: string;
	goHome?: (event: React.MouseEvent<HTMLButtonElement>) => void;
	goBack?: (event: React.MouseEvent<HTMLButtonElement>) => void;
	showHelpButton?: boolean;
	compact?: boolean;
}

const FourZeroFour: React.FC<FourZeroFourProps> = ({ title, icon, content, goHome, goBack, showHelpButton, compact = false }) => {
	return (
		<div className={`four-zero-four-container ${compact ? "compact" : ""}`}>
			<div className="four-zero-four-wrapper">
				<div className="four-zero-four-header">
					{icon && <Icon icon={icon} />}
					<h1>{title}</h1>
				</div>
				{content && (
					<div className="four-zero-four-content">
						<p dangerouslySetInnerHTML={{ __html: content }}></p>
					</div>
				)}

				<div className="four-zero-four-button-wrapper">
					{goHome && (
						<Button purpose="primary" classes="btn-sm" onClick={goHome}>
							<Icon icon="home" />
							Home
						</Button>
					)}
					{goBack && (
						<Button purpose="link" type="button" classes="btn-sm" onClick={goBack}>
							<Icon icon="arrow-left" />
							Back
						</Button>
					)}
					{showHelpButton && (
						<Button
							purpose="link"
							classes="btn-sm"
							onClick={() => window.open("https://get.brushfire.help/hc/en-us/", "_blank")}
						>
							<Icon icon="question-circle" />
							Help
						</Button>
					)}
				</div>
			</div>
		</div>
	);
};

export default FourZeroFour;
